(function () {
  'use strict';

  const englishTitle = 'Customers are saying';
  const germanTitle = 'Das sagen unsere Kundinnen und Kunden.';

  function localizeCarouselTitles(root) {
    root.querySelectorAll('.jdgm-cards-carousel .jdgm-title').forEach((title) => {
      if (title.textContent.trim() === englishTitle) title.textContent = germanTitle;
    });
  }

  function placeReviewRatingsAfterReviewerDetails() {
    document.querySelectorAll('.jm-review-item').forEach((review) => {
      if (review.closest('.jdgm-cards-carousel')) return;
      if (!review.closest('.jdgm-modal, .jdgm-review-widget')) return;

      const reviewerInfo = review.querySelector('.jm-reviewer-info');
      const rating = review.querySelector('.jm-star-rating');

      if (!reviewerInfo || !rating) return;

      const currentWrapper = reviewerInfo.parentElement;
      if (currentWrapper?.classList.contains('rfa-reviewer-with-rating')) {
        if (!currentWrapper.contains(rating)) currentWrapper.append(rating);
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'rfa-reviewer-with-rating';
      reviewerInfo.before(wrapper);
      wrapper.append(reviewerInfo, rating);
    });
  }

  function initializeJudgeMeLocalization() {
    localizeCarouselTitles(document);
    placeReviewRatingsAfterReviewerDetails();

    let updateQueued = false;
    const queueJudgeMeUpdate = () => {
      if (updateQueued) return;

      updateQueued = true;
      window.requestAnimationFrame(() => {
        updateQueued = false;
        localizeCarouselTitles(document);
        placeReviewRatingsAfterReviewerDetails();
      });
    };

    const observer = new MutationObserver(queueJudgeMeUpdate);

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeJudgeMeLocalization, { once: true });
  } else {
    initializeJudgeMeLocalization();
  }
})();
